function changeFieldsByTemplate() {
    checklist_id = $("input.template").val();
    if (checklist_id) {
      start_description = $("#form-checklist-data > #checklist-" + checklist_id).attr('start_description');
      $('p#description').text(start_description);

      data_document_required = $("#form-checklist-data > #checklist-" + checklist_id).attr('data_document_required');
      document_is_required = $('input[name=data_document]').parent().hasClass("required");
      if (data_document_required == "True" && document_is_required == false) {
        $('input[name=data_document]').parent().addClass("required");
      } else if (data_document_required == "False" && document_is_required) {
        $('input[name=data_document]').parent().removeClass("required");
      }
    }
 }

const registerChangeRoutinesForm = () => {
  $(function () {
    changeFieldsByTemplate();
    $("input.template").change(function(){
      changeFieldsByTemplate();
    });
  });
};

const registerChangeRoutinesFormByTemplate = () => {
  registerChangeRoutinesForm();
};

window.registerChangeRoutinesFormByTemplate = registerChangeRoutinesFormByTemplate;
